/**
 * @example
 * ```html
 * <section use-challenge="valentine2025" challenge-key="$2y$10$yMaKJWtxg3bIxQDOyLB2.e5200/AoWXcla8jpWOXNG7F/95GYbSrm">
 * </section>
 * ```
 * @group DOM Attribute
 */
export const CHALLENGE_KEY = 'challenge-key';
